export const TIKTOK_AUTH_REFRESH_EVENT_KEY = "tikTokAuthRefresh";

